import cloneDeep from 'lodash-es/cloneDeep';
import { startEditingAction } from '../designerReducer';

import { selectDesign } from '@/store/designer/selectors';

export const startDesignerWithACopy = designID => (dispatch, getState) => {
  const design = cloneDeep(selectDesign(getState(), designID));
  const name = design.name.substr(0, 22) + ' (копия)';
  dispatch(startEditingAction({ ...design, id: '0', name }));
};
